import React from 'react'
import styled from 'styled-components'
import { MEDIUM, TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import monetisation from './assets/monetisation.png'
import monetisation2x from './assets/monetisation@2x.png'
import devops from './assets/devops.png'
import devops2x from './assets/devops@2x.png'
import gaming from './assets/gaming.png'
import gaming2x from './assets/gaming@2x.png'
import iot from './assets/iot.png'
import iot2x from './assets/iot@2x.png'
import middleware from './assets/middleware.png'
import middleware2x from './assets/middleware@2x.png'
import blockchain from './assets/blockchain.png'
import blockchain2x from './assets/blockchain@2x.png'
import Container from '~shared/Container'
import Topic from '~shared/Topic'

const Grid = styled.div`
    display: inline-grid;
    grid-template-columns: 1fr;
    grid-row-gap: 2.5rem;
    margin: 0 auto;

    @media (min-width: ${TABLET}px) {
        grid-template-columns: repeat(2, 280px);
        grid-column-gap: 4rem;
        grid-row-gap: 4rem;
    }

    @media (min-width: ${DESKTOP}px) {
        grid-template-columns: repeat(3, 360px);
        grid-column-gap: 2.5rem;
        grid-row-gap: 5.5rem;
    }
`

const Figure = styled.div`
    background-color: #FFFFFF;
    border-radius: 8px;
    position: relative;
    height: 192px;

    img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        max-width: 192px;
    }

    @media (min-width: ${DESKTOP}px) {
        height: 160px;

        img {
            max-width: 160px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        height: 240px;

        img {
            max-width: 300px;
        }
    }
`

const Example = styled.div`
    text-align: left;
    font-size: 1rem;
    line-height: 1.75rem;

    ${Figure} {
        margin-bottom: 1.5rem;
    }

    h3 {
        margin: 0;
        font-weight: ${MEDIUM};
    }

    p {
        margin: 0;
    }

    @media (min-width: ${TABLET}px) {
        font-size: 1.125rem;
        line-height: 1.875rem;
    }
`

const UnstyledNetworkUseCases = (props) => (
    <Container {...props}>
        <div>
            <Topic.Title $appear>
                Use cases
            </Topic.Title>
            <Topic.Paragraph $appear>
                The Streamr network opens up a world of innovation by connecting unstoppable
                pub/sub real-time data transport to the vibrant ecosystem of decentralized finance
            </Topic.Paragraph>
        </div>
        <Grid>
            <Example $appear>
                <Figure>
                    <img src={monetisation} srcSet={monetisation2x} alt="Data Monetisation" />
                </Figure>
                <h3>Data Monetisation</h3>
                <p>Buy and sell access to ethically sourced data streams with Data Products and Data Unions</p>
            </Example>
            <Example $appear>
                <Figure>
                    <img src={devops} srcSet={devops2x} alt="DevOps" />
                </Figure>
                <h3>DevOps</h3>
                <p>Gather metrics from decentralized systems such as blockchain networks</p>
            </Example>
            <Example $appear>
                <Figure>
                    <img src={gaming} srcSet={gaming2x} alt="Gaming" />
                </Figure>
                <h3>Gaming</h3>
                <p>Capable of being the real-time networking layer of massive multiplayer games</p>
            </Example>
            <Example $appear>
                <Figure>
                    <img src={iot} srcSet={iot2x} alt="IoT messaging" />
                </Figure>
                <h3>IoT messaging</h3>
                <p>Publish and broadcast messages from any kind of internet-connected device</p>
            </Example>
            <Example $appear>
                <Figure>
                    <img src={middleware} srcSet={middleware2x} alt="Networking middleware" />
                </Figure>
                <h3>Networking middleware</h3>
                <p>Transfer metadata for VoIP or WebRTC signalling</p>
            </Example>
            <Example $appear>
                <Figure>
                    <img src={blockchain} srcSet={blockchain2x} alt="Blockchain networking" />
                </Figure>
                <h3>Blockchain networking</h3>
                <p>DDoS resistant block transfer or broadcast signed transactions with low and predictable latency</p>
            </Example>
        </Grid>
    </Container>
)

const NetworkUseCases = styled(UnstyledNetworkUseCases)`
    ${Topic.Title} {
        margin: 0;
    }

    ${Topic.Paragraph} {
        display: none;
    }

    ${Grid} {
        margin-top: 2.5rem;
    }

    @media (min-width: ${TABLET}px) {
        ${Grid} {
            margin-top: 7rem;
        }

        ${Topic.Title} {
            margin-bottom: 2rem;
        }

        ${Topic.Paragraph} {
            display: block;
            text-align: center;
            font-size: 1rem;
            line-height: 1.75rem;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        padding: 0;
        max-width: 72.5rem;
        text-align: center;

        ${Grid} {
            margin-top: 10.5rem;
        }

        ${Topic.Title} {
            margin-bottom: 2.5rem;
        }

        ${Topic.Paragraph} {
            font-size: 1.125rem;
            line-height: 1.875rem;
            margin: 0 auto;
            max-width: 44rem;
        }
    }
`

export default NetworkUseCases
